import { Box, Stack, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FC } from "react";
import {
  RequirementDomainSwatch,
  collectRequirementDomainSwatches,
} from "utils/requirementDomains";

type DomainColorSquaresProps = {
  domains?: RequirementDomainSwatch[];
  requirement?: {
    domains?: any;
    competencies?: any;
  } | null;
  size?: number;
  showLabels?: boolean;
};

export const DomainColorSquares: FC<DomainColorSquaresProps> = ({
  domains,
  requirement,
  size = 10,
  showLabels,
}) => {
  const theme = useTheme();
  const isCompact = useMediaQuery(theme.breakpoints.down("md"));
  const displayLabels = showLabels ?? isCompact;
  const swatches =
    domains || collectRequirementDomainSwatches(requirement || null);
  if (swatches.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={displayLabels ? 1 : 0.5}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
      component="span"
    >
      {swatches.map((domain) => {
        const swatch = (
          <Box
            component="span"
            aria-label={domain.name}
            sx={{
              width: size,
              height: size,
              bgcolor: domain.color_hex,
              border: "1px solid rgba(0,0,0,0.18)",
              borderRadius: "2px",
              flexShrink: 0,
              display: "inline-block",
            }}
          />
        );

        if (displayLabels) {
          return (
            <Stack
              key={domain.requirement_domain_id}
              direction="row"
              spacing={0.75}
              alignItems="center"
              component="span"
            >
              {swatch}
              <Typography variant="caption" color="text.secondary">
                {domain.name}
              </Typography>
            </Stack>
          );
        }

        return (
          <Tooltip
            key={domain.requirement_domain_id}
            title={domain.name}
            arrow
            placement="top"
          >
            {swatch}
          </Tooltip>
        );
      })}
    </Stack>
  );
};
